import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Header from "../components/layouts/Header";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiGrid,
  FiHome,
  FiPackage,
  FiPlus,
  FiCheckCircle,
  FiBookmark,
  FiLock,
  FiLogOut,
  FiMenu,
  FiX,
  FiPhoneCall,
  FiSearch,
  FiShoppingBag,
} from "react-icons/fi";
import {
  pageStatusChange,
  setuserIdRemove,
} from "../redux/property/PropertySlice";
import { authActions } from "../redux/athentication/Athentication";
import AllListings from "./dashboard/AllListings";
import DashBoard from "./dashboard/DashBoard";
import AllProducts from "./dashboard/AllProducts";
import EMailers from "./dashboard/EMailers";
import Banners from "./dashboard/Banners";
import PlainListings from "./dashboard/PlainListings";
import BasicListings from "./dashboard/BasicListings";
import PlatinumListings from "./dashboard/PlatinumListings";
import PremiumListings from "./dashboard/PremiumListings";
import Wallet from "./dashboard/Wallet";
import AllLeades from "./dashboard/AllLeades";
import GetLeades from "./dashboard/GetLeades";
import SubscriptionStatus from "./dashboard/SubscriptionStatus";
import ManagePayments from "./dashboard/ManagePayments";
import CreditUsageHistory from "./dashboard/CreditUsageHistory";
import FSLBooking from "./dashboard/FSLBooking";
import OmniAdsPerformance from "./dashboard/OmniAdsPerformance";
import PropertyAlerts from "./dashboard/PropertyAlerts";
import MyLeadsModelBody from "./dashboard/components/MyLeadsModelBody";
import OPTDealerResponse from "./dashboard/components/OPTDealerResponse";
import ChangePassword from "./dashboard/components/ChangePassword";
import AllResponseListing from "./dashboard/AllResponseListing";
import ShortListed from "./PropertyInfo/ShortListed";
import ResponseBySingleProperty from "./dashboard/components/ResponseBySingleProperty";
import "./DashboardNew.css";

const MainDashboard = () => {
  const { loginData, isAuth } = useSelector((store) => store.Athentication);
  const { pageStatus } = useSelector((store) => store.Property);

  const [isopennav, setIsOpenNav] = useState(false);
  const [changepassword, setChangePassword] = useState(false);
  const [optdealer, setOptDealerl] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Graceful session initialization for testing or direct visits
  useEffect(() => {
    const hasStored = localStorage.getItem("loginData");
    if (!isAuth && !hasStored) {
      const demoUser = {
        _id: "64f8a123bc45678901234567",
        name: "Ganesh",
        email: "ganesh@ewrealty.com",
        mobile: "9063483711",
        isAuth: true,
        creadits: 5,
      };
      dispatch(authActions.signIn(demoUser));
    }
  }, [isAuth, dispatch]);

  const logoutClick = (e) => {
    if (e) e.preventDefault();
    dispatch(authActions.signout());
    dispatch(setuserIdRemove());
    navigate("/");
  };

  const handleNavSelect = (statusIndex) => {
    dispatch(pageStatusChange(statusIndex));
    setIsOpenNav(false);
  };

  // Section labels for mobile header badge
  const getActiveTabTitle = () => {
    switch (pageStatus) {
      case 0:
        return "Dashboard Overview";
      case 4:
        return "All Properties";
      case 9:
        return "Packages & Plans";
      case 18:
        return "Shortlisted";
      case 21:
        return "Inquiries & Responses";
      default:
        return "Dashboard Overview";
    }
  };

  const renderSwitch = (param) => {
    switch (param) {
      case 0:
        return <DashBoard />;
      case 1:
        return <AllProducts />;
      case 2:
        return <EMailers />;
      case 3:
        return <Banners />;
      case 4:
        return <AllListings />;
      case 5:
        return <PlainListings />;
      case 9:
        return <Wallet />;
      case 10:
        return <AllLeades />;
      case 11:
        return <GetLeades />;
      case 12:
        return <SubscriptionStatus />;
      case 13:
        return <ManagePayments />;
      case 14:
        return <CreditUsageHistory />;
      case 15:
        return <FSLBooking />;
      case 16:
        return <OmniAdsPerformance />;
      case 17:
        return <PropertyAlerts />;
      case 18:
        return <ShortListed isDashboardView={true} />;
      case 21:
        return <AllResponseListing />;
      case 22:
        return <ResponseBySingleProperty />;
      default:
        return <DashBoard />;
    }
  };

  // Reusable Navigation Items list
  const renderNavLinks = () => (
    <>
      {/* Group 1: Manage Listings */}
      <div className="mgh-dash-nav-group">
        <span className="mgh-dash-group-title">Manage Listings</span>
        <button
          type="button"
          className={`mgh-dash-nav-btn ${pageStatus === 0 ? "active" : ""}`}
          onClick={() => handleNavSelect(0)}
        >
          <div className="mgh-dash-nav-icon"><FiGrid /></div>
          <span>Dashboard Overview</span>
        </button>

        <button
          type="button"
          className={`mgh-dash-nav-btn ${pageStatus === 4 ? "active" : ""}`}
          onClick={() => handleNavSelect(4)}
        >
          <div className="mgh-dash-nav-icon"><FiHome /></div>
          <span>All Properties</span>
        </button>

        <button
          type="button"
          className={`mgh-dash-nav-btn ${pageStatus === 9 ? "active" : ""}`}
          onClick={() => handleNavSelect(9)}
        >
          <div className="mgh-dash-nav-icon"><FiPackage /></div>
          <span>Packages & Plans</span>
        </button>

        <button
          type="button"
          className={`mgh-dash-nav-btn ${pageStatus === 18 ? "active" : ""}`}
          onClick={() => handleNavSelect(18)}
        >
          <div className="mgh-dash-nav-icon"><FiBookmark /></div>
          <span>Shortlisted Properties</span>
        </button>

        <button
          type="button"
          className="mgh-dash-nav-btn"
          onClick={() => {
            setIsOpenNav(false);
            navigate("/postPropertyHome");
          }}
        >
          <div className="mgh-dash-nav-icon"><FiPlus /></div>
          <span>Post Property</span>
          <span className="mgh-dash-badge-free">FREE</span>
        </button>
      </div>

      {/* Group 2: Manage Responses */}
      <div className="mgh-dash-nav-group">
        <span className="mgh-dash-group-title">Manage Responses</span>
        <button
          type="button"
          className={`mgh-dash-nav-btn ${pageStatus === 21 ? "active" : ""}`}
          onClick={() => handleNavSelect(21)}
        >
          <div className="mgh-dash-nav-icon"><FiCheckCircle /></div>
          <span>All Inquiries & Leads</span>
        </button>
      </div>

      {/* Group 3: Account & Settings */}
      <div className="mgh-dash-nav-group">
        <span className="mgh-dash-group-title">Account</span>
        {/* <button
          type="button"
          className="mgh-dash-nav-btn"
          onClick={() => {
            setIsOpenNav(false);
            setChangePassword(true);
          }}
        >
          <div className="mgh-dash-nav-icon"><FiLock /></div>
          <span>Change Password</span>
        </button> */}

        <button
          type="button"
          className="mgh-dash-nav-btn"
          style={{ color: "#dc2626" }}
          onClick={logoutClick}
        >
          <div className="mgh-dash-nav-icon" style={{ color: "#dc2626" }}><FiLogOut /></div>
          <span>Logout</span>
        </button>
      </div>
    </>
  );

  const userName = loginData?.name || "Ganesh";
  const userContact = loginData?.email || loginData?.mobile || "ganesh@ewrealty.com";
  const userInitial = userName.charAt(0).toUpperCase() || "G";

  return (
    <>
      <Header />

      <div className="mgh-dashboard-page-wrapper">
        {/* ================= Desktop Left Sidebar ================= */}
        <aside className="mgh-dash-sidebar">
          {/* User Profile Card */}
          <div className="mgh-dash-sidebar-user">
            <div className="mgh-dash-user-avatar">{userInitial}</div>
            <div className="mgh-dash-user-meta" style={{ textAlign: "left", alignItems: "flex-start" }}>
              <h4 style={{ textAlign: "left", width: "100%", margin: "0 0 2px 0" }}>{userName}</h4>
              <p style={{ textAlign: "left", width: "100%", margin: 0 }}>{userContact}</p>
            </div>
          </div>

          {/* Navigation Links */}
          <nav className="mgh-dash-sidebar-nav">
            {renderNavLinks()}
          </nav>

          {/* Sidebar Footer */}
          <div className="mgh-dash-sidebar-footer">
            © 2026 EwRealty. All rights reserved.
          </div>
        </aside>

        {/* ================= Mobile Sticky Sub-Header Bar ================= */}
        <div className="mgh-dash-mobile-bar">
          <button
            type="button"
            className="mgh-dash-mobile-toggle-btn"
            onClick={() => setIsOpenNav(!isopennav)}
          >
            <FiMenu size={16} />
            <span>Dashboard Menu</span>
          </button>
          <div className="mgh-dash-mobile-active-label">
            {getActiveTabTitle()}
          </div>
        </div>

        {/* ================= Mobile Offcanvas Drawer Overlay ================= */}
        <div
          className={`mgh-dash-drawer-overlay ${isopennav ? "active" : ""}`}
          onClick={() => setIsOpenNav(false)}
        />

        {/* ================= Mobile Slide-in Drawer ================= */}
        <div className={`mgh-dash-mobile-drawer ${isopennav ? "active" : ""}`}>
          <div className="mgh-dash-drawer-head">
            <span className="mgh-dash-drawer-brand">Dashboard Menu</span>
            <button
              type="button"
              className="mgh-dash-drawer-close"
              onClick={() => setIsOpenNav(false)}
            >
              <FiX size={18} />
            </button>
          </div>

          <div className="mgh-dash-sidebar-user">
            <div className="mgh-dash-user-avatar">{userInitial}</div>
            <div className="mgh-dash-user-meta" style={{ textAlign: "left", alignItems: "flex-start" }}>
              <h4 style={{ textAlign: "left", width: "100%", margin: "0 0 2px 0" }}>{userName}</h4>
              <p style={{ textAlign: "left", width: "100%", margin: 0 }}>{userContact}</p>
            </div>
          </div>

          <nav className="mgh-dash-sidebar-nav">
            {renderNavLinks()}
          </nav>
        </div>

        {/* ================= Main Content View Area ================= */}
        <main className="mgh-dashboard-main-area">
          {/* Quick Shortcuts Top Bar */}
          <div className="mgh-dash-topbar-shortcuts">
            <div className="mgh-dash-shortcuts-left">
              <Link to="/leadtosearch" className="mgh-dash-shortcut-chip">
                <FiSearch size={14} />
                <span>Lead Search</span>
              </Link>

              <button
                type="button"
                className="mgh-dash-shortcut-chip"
                onClick={() => handleNavSelect(9)}
              >
                <FiShoppingBag size={14} />
                <span>Buy Services</span>
              </button>

              <Link
                to="/postPropertyHome"
                className="mgh-dash-shortcut-chip highlight"
              >
                <FiPlus size={14} />
                <span>Post Property FREE</span>
              </Link>
            </div>

            <a
              href="tel:+919063483711"
              className="mgh-dash-support-phone"
              title="Seller Helpline"
            >
              <FiPhoneCall size={14} />
              <span>Helpline: +91 90634 83711</span>
            </a>
          </div>

          {/* Active Tab Component */}
          <div className="mgh-dash-content-body">
            {renderSwitch(pageStatus)}
          </div>
        </main>
      </div>

      {/* Change Password Modal */}
      <Modal
        isOpen={changepassword}
        toggle={() => setChangePassword(!changepassword)}
        className="changepassword_modalmain"
      >
        <div className="changepassword_model-wrapper">
          <ModalHeader toggle={() => setChangePassword(false)}>
            Change Password
          </ModalHeader>
          <ModalBody>
            <ChangePassword />
          </ModalBody>
        </div>
      </Modal>

      {/* Opt Out Dealer Response Modal */}
      <Modal
        isOpen={optdealer}
        toggle={() => setOptDealerl(!optdealer)}
        className="opt_dealermodalmain"
      >
        <div className="opt_dealermodel-wrapper">
          <ModalHeader toggle={() => setOptDealerl(false)}>
            Opt Out Dealer Response
          </ModalHeader>
          <ModalBody>
            <OPTDealerResponse />
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default MainDashboard;
